export default {"src":"/_next/static/media/warningIcon.c6078b4a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};